<template>
  <div class="echarts">
    <vice-title>
      <h3>{{ this.$t("lang.About.contactUs") }}</h3>
    </vice-title>
    <div class="address-detail">
      <div class="address-country">
        <h3>{{ this.$t("lang.About.chinaAddress") }}</h3>
        <ul>
          <li>{{ this.$t("lang.About.hefei") }}</li>
          <li>{{ this.$t("lang.About.beijing") }}</li>
          <li>{{ this.$t("lang.About.shanghai") }}</li>
          <li>{{ this.$t("lang.About.shenzhen") }}</li>
        </ul>
      </div>
      <div class="address-country">
        <h3>{{ this.$t("lang.About.usaAddress") }}</h3>
        <ul>
          <li>{{ this.$t("lang.About.usaAddress1") }}</li>
          <li>{{ this.$t("lang.About.usaAddress2") }}</li>
        </ul>
      </div>
      <div class="address-country">
        <h3>{{ this.$t("lang.About.japanAddress") }}</h3>
        <ul>
          <li>{{ this.$t("lang.About.japanAddress1") }}</li>
        </ul>
      </div>
    </div>
    <div class="address">
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.shanghai')"
        placement="top"
      >
        <span class="iconfont address-icon shanghai">&#xe650;</span>-->
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.beijing')"
        placement="top"
      >
        <span class="iconfont address-icon beijing">&#xe650;</span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.shenzhen')"
        placement="top"
      >
        <span class="iconfont address-icon shenzhen">&#xe650;</span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.hefei')"
        placement="top"
      >
        <span class="iconfont address-icon hefei">&#xe650;</span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.usaAddress1')"
        placement="top"
      >
        <span class="iconfont address-icon newYork">&#xe650;</span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.usaAddress2')"
        placement="top"
      >
        <span class="iconfont address-icon houston">&#xe650;</span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        :content="this.$t('lang.About.japanAddress1')"
        placement="top"
      >
        <span class="iconfont address-icon tokyo">&#xe650;</span>
      </el-tooltip>
    </div>
    <!--    <div :style="{ height: height, width: width }" ref="myEchart"></div>-->
  </div>
</template>
<script>
// import echarts from "echarts"; //引入组件
// import "../../../node_modules/echarts/map/js/world.js"; //引入组件
import ViceTitle from "../ViceTitle";
export default {
  name: "echarts",
  components: {
    ViceTitle
  },
  data() {
    return {
      meiguo: false,
      zhongguo: false
    };
  },
  mounted() {},
  methods: {
    handleCIn() {
      this.zhongguo = true;
    },
    handleCOut() {
      this.zhongguo = false;
    },
    handleAIn() {
      this.meiguo = true;
    },
    handleAOut() {
      this.meiguo = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
.echarts {
  width: 75%;
  margin: 0 auto 50px auto;
  overflow: hidden;
  .address-detail {
    color: #828282;
    margin-bottom: 20px;
    .address-country {
      h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 20px 0;
      }
      li {
        line-height: 24px;
      }
    }
  }
  .address {
    position: relative;
    height: 600px;
    background: url("../../assets/images/map.png");
    background-size: 100% 100%;
    .address-icon {
      position: absolute;
      font-size: 26px;
      cursor: pointer;
      color: #f56c6c;
    }
    .shanghai {
      right: 22.7%;
      top: 31%;
    }
    .beijing {
      top: 24%;
      right: 24.5%;
    }
    .shenzhen {
      right: 24%;
      top: 36.3%;
    }
    .hefei {
      right: 25%;
      top: 30.8%;
    }
    .houston {
      left: 13%;
      top: 31.5%;
    }
    .newYork {
      left: 17.8%;
      top: 26%;
    }
    .tokyo {
      right: 17.8%;
      top: 27.5%;
    }
  }
}
</style>
